export enum EOrderType {
    asc = 0,
    desc = 1,
    none = 2
}

export interface ISortOptions {
    columnName: string;
    orderType: EOrderType;
}

export interface IPaginationOptions {
    currentPage: number;
    pageSize: number;
}